module.exports = __webpack_public_path__ + "img/time-icon.0677b58a.png";